import React from 'react';
import Modal from 'react-modal';
import translator from '../../common/translate';
import AuthService from '../../Auth/AuthService';
import ExternalLink from '../ExternalLink';
import SangomaLogo from '../../assets/images/sangoma-logo.png';
import EmblemLarge from '../EmblemComponent';
import './login.css';

// The user has chosen to log in: the browser must not ask to confirm leaving the page with unsaved changes
const handleLoginClick = () => {
  window.onbeforeunload = null;
};

export default function Login() {
  return (
    <Modal
      isOpen={true}
      overlayClassName="default-overlay-modal login-overlay-modal"
      className="login-modal"
      ariaHideApp={false}
    >
      <div className="login-modal-left-part">
        <img className="login-modal__logo" src={SangomaLogo} alt="Sangoma" />
        <a
          id="login-with-sangoma-sso"
          className="btn large login-modal__login-btn"
          href={AuthService.getLoginUrlToCurrentRoute()}
          onClick={handleLoginClick}
        >
          {translator.getMessage('msg_login_with_sangoma_sso')}
        </a>
        <footer className="login-modal__legal">
          <div>
            <ExternalLink
              path="https://sangoma.com/terms"
              title={translator.getMessage('msg_about_dialog_link_terms_of_use')}
            />
            &nbsp;|&nbsp;
            <ExternalLink
              path="https://sangoma.com/privacy-policy"
              title={translator.getMessage('msg_about_dialog_link_privacy_policy')}
            />
          </div>
          <div>
            &copy;{new Date().getFullYear()}&nbsp;{translator.getMessage('msg_sangoma_all_rights_reserved')}
          </div>
        </footer>
      </div>
      <div className="login-modal-right-part">
        <EmblemLarge />
      </div>
    </Modal>
  );
}
